import { __extends } from "tslib";
import React from 'react';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Spacer } from '../components/spacer';
import { WrapperItem } from '../components/wrapper-item';
var SectionSpacer = /** @class */ (function (_super) {
    __extends(SectionSpacer, _super);
    function SectionSpacer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionSpacer.prototype.render = function () {
        var _a = this.props, section = _a.section, cssClass = _a.cssClass;
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { padding: "0", borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, borderBottom: section.borderBottom },
                React.createElement(Column, null,
                    React.createElement(Spacer, { cssClass: cssClass, height: section.height + "px", containerBackgroundColor: section.backgroundColor })))));
    };
    return SectionSpacer;
}(React.Component));
export { SectionSpacer };
//# sourceMappingURL=section-spacer.js.map